import { Link, useRouterState } from '@tanstack/react-router';

import {
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
  Breadcrumb as BreadcrumbUI,
} from '../ui/breadcrumb';

export const Breadcrumb = (): JSX.Element => {
  const matches = useRouterState({ select: s => s.matches }).filter(
    ({ context: { title } }) => title !== undefined,
  );

  return (
    <BreadcrumbUI>
      <BreadcrumbList>
        {matches
          .reduce<{
            lastTitle: string | undefined;
            elements: JSX.Element[];
          }>(
            ({ lastTitle, elements }, { pathname, context: { title }, id }) => {
              if (lastTitle === title) {
                return { lastTitle, elements };
              }

              return {
                lastTitle: title,
                elements: [
                  ...elements,
                  <BreadcrumbItem key={`item-${id}`}>
                    <BreadcrumbLink asChild>
                      <Link to={pathname}>{title}</Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>,
                  <BreadcrumbSeparator key={`separator-${id}`}>
                    /
                  </BreadcrumbSeparator>,
                ],
              };
            },
            { lastTitle: undefined, elements: [] },
          )
          .elements.slice(0, -1)}
      </BreadcrumbList>
    </BreadcrumbUI>
  );
};
